
export enum AppModeEnum {
	initDataStart = 'initDataStart',
	initDataSuccess = 'initDataSuccess',
	initDataFailed = 'initDataFailed',

	appSuccess = 'appSuccess',
	appFailed = 'appFailed',
}